"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1() {
    /**
     * See useragents.js for examples of navigator.userAgent
     */
    var t = true;
    function detect(ua) {
        function getFirstMatch(regex) {
            var match = ua.match(regex);
            return (match && match.length > 1 && match[1]) || '';
        }
        function getSecondMatch(regex) {
            var match = ua.match(regex);
            return (match && match.length > 1 && match[2]) || '';
        }
        var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase();
        var likeAndroid = /like android/i.test(ua);
        var android = !likeAndroid && /android/i.test(ua);
        var nexusMobile = /nexus\s*[0-6]\s*/i.test(ua);
        var nexusTablet = !nexusMobile && /nexus\s*[0-9]+/i.test(ua);
        var chromeos = /CrOS/.test(ua) || /chrome os/i.test(ua);
        var silk = /silk/i.test(ua);
        var sailfish = /sailfish/i.test(ua);
        var tizen = /tizen/i.test(ua);
        var webos = /(web|hpw)([o0])s/i.test(ua);
        var windowsphone = /windows phone/i.test(ua);
        // eslint-disable-next-line no-unused-vars
        var samsungBrowser = /SamsungBrowser/i.test(ua);
        var windows = !windowsphone && (/windows/i.test(ua) || /win32/i.test(ua));
        var mac = !iosdevice && !silk && /macintosh/i.test(ua);
        var linux = !android && !sailfish && !tizen && !webos && /linux/i.test(ua);
        var edgeVersion = getSecondMatch(/edg([ea]|ios)\/(\d+(\.\d+)?)/i);
        var versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i);
        var tablet = /tablet/i.test(ua) && !/tablet pc/i.test(ua);
        var mobile = !tablet && /[^-]mobi/i.test(ua);
        var xbox = /xbox/i.test(ua);
        var playstation = /playstation/i.test(ua);
        var result;
        if (/opera/i.test(ua)) {
            //  an old Opera
            result = {
                name: 'Opera',
                opera: t,
                version: versionIdentifier || getFirstMatch(/(?:opera|opr|opios)[\s/](\d+(\.\d+)?)/i)
            };
        }
        else if (/opr\/|opios/i.test(ua)) {
            // a new Opera
            result = {
                name: 'Opera',
                opera: t,
                version: getFirstMatch(/(?:opr|opios)[\s/](\d+(\.\d+)?)/i) || versionIdentifier
            };
        }
        else if (/SamsungBrowser/i.test(ua)) {
            result = {
                name: 'Samsung Internet for Android',
                samsungBrowser: t,
                version: versionIdentifier || getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.\d+)?)/i)
            };
        }
        else if (/Whale/i.test(ua)) {
            result = {
                name: 'NAVER Whale browser',
                whale: t,
                version: getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i)
            };
        }
        else if (/MZBrowser/i.test(ua)) {
            result = {
                name: 'MZ Browser',
                mzbrowser: t,
                version: getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i)
            };
        }
        else if (/coast/i.test(ua)) {
            result = {
                name: 'Opera Coast',
                coast: t,
                version: versionIdentifier || getFirstMatch(/(?:coast)[\s/](\d+(\.\d+)?)/i)
            };
        }
        else if (/focus/i.test(ua)) {
            result = {
                name: 'Focus',
                focus: t,
                version: getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i)
            };
        }
        else if (/yabrowser/i.test(ua)) {
            result = {
                name: 'Yandex Browser',
                yandexbrowser: t,
                version: versionIdentifier || getFirstMatch(/(?:yabrowser)[\s/](\d+(\.\d+)?)/i)
            };
        }
        else if (/ucbrowser/i.test(ua)) {
            result = {
                name: 'UC Browser',
                ucbrowser: t,
                version: getFirstMatch(/(?:ucbrowser)[\s/](\d+(?:\.\d+)+)/i)
            };
        }
        else if (/mxios/i.test(ua)) {
            result = {
                name: 'Maxthon',
                maxthon: t,
                version: getFirstMatch(/(?:mxios)[\s/](\d+(?:\.\d+)+)/i)
            };
        }
        else if (/epiphany/i.test(ua)) {
            result = {
                name: 'Epiphany',
                epiphany: t,
                version: getFirstMatch(/(?:epiphany)[\s/](\d+(?:\.\d+)+)/i)
            };
        }
        else if (/puffin/i.test(ua)) {
            result = {
                name: 'Puffin',
                puffin: t,
                version: getFirstMatch(/(?:puffin)[\s/](\d+(?:\.\d+)?)/i)
            };
        }
        else if (/sleipnir/i.test(ua)) {
            result = {
                name: 'Sleipnir',
                sleipnir: t,
                version: getFirstMatch(/(?:sleipnir)[\s/](\d+(?:\.\d+)+)/i)
            };
        }
        else if (/k-meleon/i.test(ua)) {
            result = {
                name: 'K-Meleon',
                kMeleon: t,
                version: getFirstMatch(/(?:k-meleon)[\s/](\d+(?:\.\d+)+)/i)
            };
        }
        else if (windowsphone) {
            result = {
                name: 'Windows Phone',
                osname: 'Windows Phone',
                windowsphone: t
            };
            if (edgeVersion) {
                result.msedge = t;
                result.version = edgeVersion;
            }
            else {
                result.msie = t;
                result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i);
            }
        }
        else if (/msie|trident/i.test(ua)) {
            result = {
                name: 'Internet Explorer',
                msie: t,
                version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
            };
        }
        else if (chromeos) {
            result = {
                name: 'Chrome',
                osname: 'Chrome OS',
                chromeos: t,
                chromeBook: t,
                chrome: t,
                version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
            };
        }
        else if (/edg([ea]|ios)/i.test(ua)) {
            result = {
                name: 'Microsoft Edge',
                msedge: t,
                version: edgeVersion
            };
        }
        else if (/vivaldi/i.test(ua)) {
            result = {
                name: 'Vivaldi',
                vivaldi: t,
                version: getFirstMatch(/vivaldi\/(\d+(\.\d+)?)/i) || versionIdentifier
            };
        }
        else if (sailfish) {
            result = {
                name: 'Sailfish',
                osname: 'Sailfish OS',
                sailfish: t,
                version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
            };
        }
        else if (/seamonkey\//i.test(ua)) {
            result = {
                name: 'SeaMonkey',
                seamonkey: t,
                version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
            };
        }
        else if (/firefox|iceweasel|fxios/i.test(ua)) {
            result = {
                name: 'Firefox',
                firefox: t,
                version: getFirstMatch(/(?:firefox|iceweasel|fxios)[ /](\d+(\.\d+)?)/i)
            };
            if (/\((mobile|tablet);[^)]*rv:[\d.]+\)/i.test(ua)) {
                result.firefoxos = t;
                result.osname = 'Firefox OS';
            }
        }
        else if (silk) {
            result = {
                name: 'Amazon Silk',
                silk: t,
                version: getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
            };
        }
        else if (/phantom/i.test(ua)) {
            result = {
                name: 'PhantomJS',
                phantom: t,
                version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
            };
        }
        else if (/slimerjs/i.test(ua)) {
            result = {
                name: 'SlimerJS',
                slimer: t,
                version: getFirstMatch(/slimerjs\/(\d+(\.\d+)?)/i)
            };
        }
        else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
            result = {
                name: 'BlackBerry',
                osname: 'BlackBerry OS',
                blackberry: t,
                version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
            };
        }
        else if (webos) {
            result = {
                name: 'WebOS',
                osname: 'WebOS',
                webos: t,
                version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
            };
            if (/touchpad\//i.test(ua))
                result.touchpad = t;
        }
        else if (/bada/i.test(ua)) {
            result = {
                name: 'Bada',
                osname: 'Bada',
                bada: t,
                version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
            };
        }
        else if (tizen) {
            result = {
                name: 'Tizen',
                osname: 'Tizen',
                tizen: t,
                version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
            };
        }
        else if (/qupzilla/i.test(ua)) {
            result = {
                name: 'QupZilla',
                qupzilla: t,
                version: getFirstMatch(/(?:qupzilla)[\s/](\d+(?:\.\d+)+)/i) || versionIdentifier
            };
        }
        else if (/chromium/i.test(ua)) {
            result = {
                name: 'Chromium',
                chromium: t,
                version: getFirstMatch(/(?:chromium)[\s/](\d+(?:\.\d+)?)/i) || versionIdentifier
            };
        }
        else if (/chrome|crios|crmo/i.test(ua)) {
            result = {
                name: 'Chrome',
                chrome: t,
                version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
            };
        }
        else if (android) {
            result = {
                name: 'Android',
                version: versionIdentifier
            };
        }
        else if (/safari|applewebkit/i.test(ua)) {
            result = {
                name: 'Safari',
                safari: t
            };
            if (versionIdentifier) {
                result.version = versionIdentifier;
            }
        }
        else if (iosdevice) {
            result = {
                name: iosdevice === 'iphone' ? 'iPhone' : iosdevice === 'ipad' ? 'iPad' : 'iPod'
            };
            // WTF: version is not part of user agent in web apps
            if (versionIdentifier) {
                result.version = versionIdentifier;
            }
        }
        else if (/googlebot/i.test(ua)) {
            result = {
                name: 'Googlebot',
                googlebot: t,
                version: getFirstMatch(/googlebot\/(\d+(\.\d+))/i) || versionIdentifier
            };
        }
        else {
            result = {
                name: getFirstMatch(/^(.*)\/(.*) /),
                version: getSecondMatch(/^(.*)\/(.*) /)
            };
        }
        // set webkit or gecko flag for browsers based on these engines
        if (!result.msedge && /(apple)?webkit/i.test(ua)) {
            if (/(apple)?webkit\/537\.36/i.test(ua)) {
                result.name = result.name || 'Blink';
                result.blink = t;
            }
            else {
                result.name = result.name || 'Webkit';
                result.webkit = t;
            }
            if (!result.version && versionIdentifier) {
                result.version = versionIdentifier;
            }
        }
        else if (!result.opera && /gecko\//i.test(ua)) {
            result.name = result.name || 'Gecko';
            result.gecko = t;
            result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i);
        }
        // set OS flags for platforms that have multiple browsers
        if (!result.windowsphone && (android || result.silk)) {
            result.android = t;
            result.osname = 'Android';
        }
        else if (!result.windowsphone && iosdevice) {
            result[iosdevice] = t;
            result.ios = t;
            result.osname = 'iOS';
        }
        else if (mac) {
            result.mac = t;
            result.osname = 'macOS';
        }
        else if (xbox) {
            result.xbox = t;
            result.osname = 'Xbox';
        }
        else if (playstation) {
            result.playstation = t;
            result.osname = 'PlayStation';
        }
        else if (windows) {
            result.windows = t;
            result.osname = 'Windows';
        }
        else if (linux) {
            result.linux = t;
            result.osname = 'Linux';
        }
        function getWindowsVersion(s) {
            switch (s) {
                case 'NT':
                    return 'NT';
                case 'XP':
                    return 'XP';
                case 'NT 5.0':
                    return '2000';
                case 'NT 5.1':
                    return 'XP';
                case 'NT 5.2':
                    return '2003';
                case 'NT 6.0':
                    return 'Vista';
                case 'NT 6.1':
                    return '7';
                case 'NT 6.2':
                    return '8';
                case 'NT 6.3':
                    return '8.1';
                case 'NT 10.0':
                    return '10';
                default:
                    return '';
            }
        }
        // OS version extraction
        var osVersion = '';
        if (result.windows) {
            osVersion = getWindowsVersion(getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i));
        }
        else if (result.windowsphone) {
            osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
        }
        else if (result.mac) {
            osVersion = getFirstMatch(/Mac OS X (\d+([_.\s]\d+)*)/i);
            osVersion = osVersion.replace(/[_\s]/g, '.');
        }
        else if (iosdevice) {
            osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
            osVersion = osVersion.replace(/[_\s]/g, '.');
        }
        else if (android) {
            osVersion = getFirstMatch(/android[ /-](\d+(\.\d+)*)/i);
        }
        else if (result.webos) {
            osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
        }
        else if (result.blackberry) {
            osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
        }
        else if (result.bada) {
            osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
        }
        else if (result.tizen) {
            osVersion = getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i);
        }
        if (osVersion) {
            result.osversion = osVersion;
        }
        // device type extraction
        var osMajorVersion = !result.windows ? parseInt(osVersion.split('.')[0]) : 0;
        if (tablet ||
            nexusTablet ||
            iosdevice === 'ipad' ||
            (android && (osMajorVersion === 3 || (osMajorVersion >= 4 && !mobile))) ||
            result.silk) {
            result.tablet = t;
        }
        else if (mobile ||
            iosdevice === 'iphone' ||
            iosdevice === 'ipod' ||
            android ||
            nexusMobile ||
            result.blackberry ||
            result.webos ||
            result.bada) {
            result.mobile = t;
        }
        // Graded Browser Support
        // http://developer.yahoo.com/yui/articles/gbs
        var resultOsVersion = result.osversion;
        if (result.msedge ||
            (result.msie && result.version >= 10) ||
            (result.yandexbrowser && result.version >= 15) ||
            (result.vivaldi && result.version >= 1.0) ||
            (result.chrome && result.version >= 20) ||
            (result.samsungBrowser && result.version >= 4) ||
            (result.whale && compareVersions([result.version, '1.0']) === 1) ||
            (result.mzbrowser && compareVersions([result.version, '6.0']) === 1) ||
            (result.focus && compareVersions([result.version, '1.0']) === 1) ||
            (result.firefox && result.version >= 20.0) ||
            (result.safari && result.version >= 6) ||
            (result.opera && result.version >= 10.0) ||
            (result.ios && resultOsVersion && parseInt(resultOsVersion.split('.')[0]) >= 6) ||
            (result.blackberry && result.version >= 10.1) ||
            (result.chromium && result.version >= 20)) {
            result.a = t;
        }
        else if ((result.msie && result.version < 10) ||
            (result.chrome && result.version < 20) ||
            (result.firefox && result.version < 20.0) ||
            (result.safari && result.version < 6) ||
            (result.opera && result.version < 10.0) ||
            (result.ios && resultOsVersion && parseInt(resultOsVersion.split('.')[0]) < 6) ||
            (result.chromium && result.version < 20)) {
            result.c = t;
        }
        else {
            result.x = t;
        }
        return result;
    }
    var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent || '' : '');
    bowser.test = function (browserList) {
        var browserItem;
        for (var i = 0; i < browserList.length; ++i) {
            browserItem = browserList[i];
            if (typeof browserItem === 'string') {
                if (browserItem in bowser) {
                    return true;
                }
            }
        }
        return false;
    };
    /**
     * Get version precisions count
     *
     * @example
     *   getVersionPrecision("1.10.3") // 3
     *
     * @param  {string} version
     * @return {number}
     */
    function getVersionPrecision(version) {
        return version.split('.').length;
    }
    /**
     * Calculate browser version weight
     *
     * @example
     *   compareVersions(['1.10.2.1',  '1.8.2.1.90'])    // 1
     *   compareVersions(['1.010.2.1', '1.09.2.1.90']);  // 1
     *   compareVersions(['1.10.2.1',  '1.10.2.1']);     // 0
     *   compareVersions(['1.10.2.1',  '1.0800.2']);     // -1
     *
     * @param  {Array<String>} versions versions to compare
     * @return {Number} comparison result
     */
    function compareVersions(versions) {
        // 1) get common precision for both versions, for example for "10.0" and "9" it should be 2
        var precision = Math.max(getVersionPrecision(versions[0]), getVersionPrecision(versions[1]));
        var chunkIterator = function (chunk) {
            return new Array(20 - chunk.length).join('0') + chunk;
        };
        var chunks = versions.map(function (version) {
            var delta = precision - getVersionPrecision(version);
            // 2) "9" -> "9.0" (for precision = 2)
            version = version + new Array(delta + 1).join('.0');
            // 3) "9.0" -> ["000000000"", "000000009"]
            return version.split('.').map(chunkIterator).reverse();
        });
        // iterate in reverse order by reversed chunks array
        while (--precision >= 0) {
            // 4) compare: "000000009" > "000000010" = false (but "9" > "10" = true)
            if (chunks[0][precision] > chunks[1][precision]) {
                return 1;
            }
            else if (chunks[0][precision] === chunks[1][precision]) {
                if (precision === 0) {
                    // all version chunks are same
                    return 0;
                }
            }
            else {
                return -1;
            }
        }
    }
    /**
     * Check if browser is unsupported
     *
     * @example
     *   bowser.isUnsupportedBrowser({
     *     msie: "10",
     *     firefox: "23",
     *     chrome: "29",
     *     safari: "5.1",
     *     opera: "16",
     *     phantom: "534"
     *   });
     *
     * @param  {Object}  minVersions map of minimal version to browser
     * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
     * @param  {String}  [ua] user agent string
     * @return {Boolean}
     */
    function isUnsupportedBrowser(minVersions, strictMode, ua) {
        var _bowser = bowser;
        // make strictMode param optional with ua param usage
        if (typeof strictMode === 'string') {
            ua = strictMode;
            strictMode = void 0;
        }
        if (strictMode === void 0) {
            strictMode = false;
        }
        if (ua) {
            _bowser = detect(ua);
        }
        var version = '' + _bowser.version;
        for (var browser in minVersions) {
            if (minVersions.hasOwnProperty(browser)) {
                if (_bowser[browser]) {
                    if (typeof minVersions[browser] !== 'string') {
                        throw new Error('Browser version in the minVersion map should be a string: ' +
                            browser +
                            ': ' +
                            String(minVersions));
                    }
                    // browser version and min supported version.
                    return (compareVersions([version, minVersions[browser]]) || Infinity) < 0;
                }
            }
        }
        return strictMode; // not found
    }
    /**
     * Check if browser is supported
     *
     * @param  {Object} minVersions map of minimal version to browser
     * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
     * @param  {String}  [ua] user agent string
     * @return {Boolean}
     */
    function check(minVersions, strictMode, ua) {
        return !isUnsupportedBrowser(minVersions, strictMode, ua);
    }
    bowser.isUnsupportedBrowser = isUnsupportedBrowser;
    bowser.compareVersions = compareVersions;
    bowser.check = check;
    /*
     * Set our detect method to the main bowser object so we can
     * reuse it to test other user agents.
     * This is needed to implement future tests.
     */
    bowser._detect = detect;
    /*
     * Set our detect public method to the main bowser object
     * This is needed to implement bowser in server side
     */
    bowser.detect = detect;
    return bowser;
}
exports.default = default_1;
//# sourceMappingURL=data:application/json;base64,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